import request from "@/utils/request";

// 创建视频
export const createVideo = (data) => {
    return request({
        url: "/businessservice/video/create",
        method: "post",
        data: data
    })
}

// 更新视频
export const updateVideo = (data) => {
    return request({
        url: "/businessservice/video/update",
        method: "post",
        data: data
    })
}


// 删除视频
export const  deleteVideo =(query) =>{
    return request({
        url: "/businessservice/video/delete",
        method:"get",
        params: query
    })
}

// 查询视频
export const listVideo = (data) => {
    return request({
        url: "/businessservice/video/list",
        method: "post",
        data: data
    })
}